import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { Markdown } from "src/utils/Markdown";
import { useGetDoc } from "src/api/DocsApi";
import Loading from "src/common/Loading";
import { GameGuideMDViewer } from "src/common/MDViewer";

// example - http://localhost:3000/docs/6f7ed3d0-6ed7-4591-a38a-bb53d4cba1c2?theme=black&width=640

export default function Doc() {
  const router = useRouter();
  const { slug, theme = "black", width = "640", className } = router.query;
  const [content, setContent] = useState("");

  const { data, isError, isLoading }: any = useGetDoc(slug as string);

  useEffect(() => {
    if (!!data) {
      Markdown.toHtml(data?.body ?? "").then((content) => setContent(content));
    }
  }, [data]);

  return isLoading ? (
    <Loading full={true} className={`${theme === "black" ? "bg-black" : ""}`} />
  ) : (
    <GameGuideMDViewer
      className={className as string}
      theme={theme as string}
      width={width as string}
      content={content}
    />
  );
}
